import { Injectable } from '@angular/core';
import { standardCommand } from '../../../core/model/command';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { lettingFeatureCommand } from '../../command/letting-feature-command';
import { DeleteLettingFeaturesCommandHandler } from './delete-letting-features-command-handler.service';

@Injectable()
export class LettingFeatureCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    createHandler: CreateCommandHandler,
    deleteHandler: DeleteCommandHandler,
    deleteManyHandler: DeleteLettingFeaturesCommandHandler,
    editHandler: EditCommandHandler
  ) {
    super();
    this.addHandler(standardCommand.create, createHandler);
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(lettingFeatureCommand.deleteMany, deleteManyHandler);
    this.addHandler(standardCommand.edit, editHandler);
  }
}
